@if (!dismissible || (dismissible && !dismissed)) {
    <div
        class="stria-alert-container"
        [@fadeIn]="!dismissed"
        [@fadeOut]="!dismissed"
    >
        <!-- Border -->
        @if (appearance === 'border') {
            <div class="stria-alert-border"></div>
        }

        <!-- Icon -->
        @if (showIcon) {
            <div class="stria-alert-icon">
                <!-- Custom icon -->
                <div class="stria-alert-custom-icon">
                    <ng-content select="[striaAlertIcon]"></ng-content>
                </div>

                <!-- Default icons -->
                <div class="stria-alert-default-icon">
                    @if (type === 'primary') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:check-circle'"
                        ></mat-icon>
                    }

                    @if (type === 'accent') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:check-circle'"
                        ></mat-icon>
                    }

                    @if (type === 'warn') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:x-circle'"
                        ></mat-icon>
                    }

                    @if (type === 'basic') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:check-circle'"
                        ></mat-icon>
                    }

                    @if (type === 'info') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:information-circle'"
                        ></mat-icon>
                    }

                    @if (type === 'success') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:check-circle'"
                        ></mat-icon>
                    }

                    @if (type === 'warning') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:exclamation-triangle'"
                        ></mat-icon>
                    }

                    @if (type === 'error') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:x-circle'"
                        ></mat-icon>
                    }
                </div>
            </div>
        }

        <!-- Content -->
        <div class="stria-alert-content">
            <div class="stria-alert-title">
                <ng-content select="[striaAlertTitle]"></ng-content>
            </div>

            <div class="stria-alert-message">
                <ng-content></ng-content>
            </div>
        </div>

        <!-- Dismiss button -->
        <button
            class="stria-alert-dismiss-button"
            mat-icon-button
            (click)="dismiss()"
        >
            <mat-icon [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
        </button>
    </div>
}
